import React from "react"

function Resources({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      {...props}
    >
      <path
        d="M22.7486 11.8289C23.8216 11.8289 24.6914 10.9591 24.6914 9.88612C24.6914 8.81316 23.8216 7.94336 22.7486 7.94336C21.6756 7.94336 20.8058 8.81316 20.8058 9.88612C20.8058 10.9591 21.6756 11.8289 22.7486 11.8289Z"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7481 28.1607V20.0342"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3918 20.6625H19.4266C19.2769 20.6625 19.1341 20.603 19.0288 20.4977C18.9228 20.3924 18.8641 20.2489 18.8641 20.0999C18.8641 18.7409 18.8641 15.2888 18.8641 13.9298C18.8641 13.7808 18.9228 13.6372 19.0288 13.5319C19.134 13.4267 19.2769 13.3672 19.4266 13.3672C20.5026 13.3672 22.7482 13.3672 22.7482 13.3672"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7661 20.6641H26.5577C26.7074 20.6641 26.8503 20.6046 26.9556 20.4993C27.0615 20.394 27.1203 20.2505 27.1203 20.1015C27.1203 18.7425 27.1203 15.2904 27.1203 13.9314C27.1203 13.6204 26.8688 13.3688 26.5577 13.3688C25.3779 13.3688 22.7515 13.3688 22.7515 13.3688"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8768 28.1615H18.6901C18.8589 28.1615 19.0189 28.0857 19.1262 27.9544C19.4168 27.5983 20.0067 26.875 20.2651 26.5578C20.3471 26.4573 20.3915 26.3323 20.3915 26.2024C20.3915 24.6896 20.3915 15.1187 20.3915 15.1187"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.247 28.1625H24.0603C24.2291 28.1625 24.389 28.0866 24.4964 27.9554C24.787 27.5992 25.3769 26.876 25.6352 26.5588C25.7173 26.4583 25.7617 26.3332 25.7617 26.2033C25.7617 24.6906 25.7617 15.1196 25.7617 15.1196"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.55975 23.2275H15.632"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1964 28.0855C13.1479 28.1819 13.0515 28.2448 12.9442 28.2503C12.8368 28.2557 12.735 28.2031 12.6769 28.1129C11.9291 26.9412 9.93775 23.8199 9.60686 23.3011C9.57616 23.2532 9.55975 23.1972 9.55975 23.1404C9.55975 22.0029 9.55975 10.0948 9.55975 8.04678C9.55975 7.88135 9.69372 7.74805 9.85845 7.74805C10.8914 7.74805 14.3004 7.74805 15.3333 7.74805C15.4981 7.74805 15.632 7.88135 15.632 8.04678C15.632 10.1051 15.632 22.1239 15.632 23.1568C15.632 23.2033 15.6211 23.2491 15.6006 23.2908C15.3586 23.7734 13.798 26.8858 13.1964 28.0855Z"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.55975 10.2837H15.632"
        stroke="#003E4C"
        strokeWidth="0.996521"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Resources
